module.exports = __webpack_public_path__ + "static/10-55b27da284576cdfbd2c17e1cd3b1306.jpg";